// extracted by mini-css-extract-plugin
export default {"skelet":"Skelet_skelet--GZ4","skeletShimmer":"Skelet_skeletShimmer--ZHK","skeletBlock":"Skelet_skeletBlock--tGb"};